// extracted by mini-css-extract-plugin
export var email = "SchoolLocationCard-module--email--1e65e";
export var infoWrapper = "SchoolLocationCard-module--infoWrapper--e89d1";
export var meta = "SchoolLocationCard-module--meta--669d7";
export var positionModuleUser = "SchoolLocationCard-module--positionModuleUser--dcc7b";
export var schoolLocationCard = "SchoolLocationCard-module--schoolLocationCard--77683";
export var schoolLocationCardWrapper = "SchoolLocationCard-module--schoolLocationCardWrapper--b4162";
export var visitSchoolLink = "SchoolLocationCard-module--visitSchoolLink--ca3d3";